
import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      menuOpen: false
    }
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
});
